import React, { Component } from 'react';
import { Row, Tag, Icon } from 'antd';
import SvgIcon from 'SvgIcon';

export default class SpecConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      innerKeyField: 'id',
      productNum: 0,
      value: [],
      innerTextField: 'name',
    };
  }
  componentDidMount() {
    this.props.model.addListener(this);
  }
  componentWillUnmount() {
    this.props.model.removeListener(this);
  }
  setCellState(value) {
    debugger
  }
  open = (e) => {
    this.referViewModel = e.vm;
    this.gridModel = e.vm.get('table');
    this.gridModel.addListener(this);
  }
  setListenerState(params, propertyName) {
    if (propertyName === 'table') return;
    const { keyField, checkField, childrenField, refer2BillKeyFieldMap } = params;
    delete params.keyField;
    delete params.value;
    delete params.textField;
    this.setState(params);
    this.state.keyField = keyField;
    this.state.checkField = checkField;
    this.state.childrenField = childrenField;
    this.state.billKeyField = refer2BillKeyFieldMap[this.state.innerKeyField];
    this.state.textField = refer2BillKeyFieldMap[this.state.innerTextField];
  }
  onTagClick(element) {
    let { value, keyField, billKeyField } = this.state;
    if (value.filter(v => v[billKeyField] == element[billKeyField]).length) {
      value = value.filter(v => v[billKeyField] !== element[billKeyField])
    } else {
      value = value.filter(v => v[keyField] !== element[keyField])
      value.push(element)
    }
    this.props.model.setValue(value, true);
    this.setState({ value })
  }
  renderTagItem(data) {
    const { textField, value, billKeyField } = this.state;
    if (!data || !data.length)
      return null;
    const items = [];
    data.forEach((element) => {
      items.push(
        <div className='tag_group'>
          <Tag
            className={value.filter(v => v[billKeyField] == element[billKeyField]).length ? 'checked_tag' : ''}
            onClick={() => this.onTagClick(element)}
            onClose={(e) => this.onClose(e, element.index)}
          ><span className={element[textField].length <= 5 ? 'short_item' : 'long_item'}>{element[textField]}</span></Tag>
          {value.filter(v => v[billKeyField] == element[billKeyField]).length ? <SvgIcon type='chongzhixuanzhong' /> : null}
        </div>
      );
    });
    return items;
  }
  renderTag(item) {
    const { data, text } = item;
    return (
      <Row>
        <div className="pic-book-title"><span>{text}</span></div>
        {this.renderTagItem(data)}
      </Row>
    );
  }
  addProductNum = () => {
    let { productNum } = this.state;
    productNum++;
    this.setState({
      productNum: productNum
    })
  }
  reduceProductNum = () => {
    let { productNum } = this.state;
    productNum--;
    this.setState({
      productNum: productNum
    })
  }
  groupDataSource(dataSource) {
    const { keyField } = this.state;
    let map = {}, dest = [];
    for (var i = 0; i < dataSource.length; i++) {//dataSource分组
      var ai = dataSource[i];
      if (!map[ai[keyField]]) {
        dest.push({
          iSpecId: ai[keyField],
          text: ai.iSpecId_showItem,
          data: [ai]
        });
        map[ai[keyField]] = ai;
      } else {
        for (var j = 0; j < dest.length; j++) {
          var dj = dest[j];
          if (dj[keyField] == ai[keyField]) {
            dj.data.push(ai);
            break;
          }
        }
      }
    }
    return dest
  }
  render() {
    const { dataSource, productNum } = this.state;
    if (!dataSource || !dataSource.length)
      return null;
    let dest = this.groupDataSource(dataSource), items = [];
    dest.forEach(item => {
      items.push(this.renderTag(item));
    });
    const numControl = <Row>
      <div>
        <Icon type="jianshaoshuliang" onClick={this.reduceProductNum} />{productNum}<Icon type="tianjiashuliang" onClick={this.addProductNum} />
      </div>
    </Row>
    // items.push(numControl)
    return (
      <div className='specconfig'>
        {items}
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/specconfig.jsx